import $ from 'jquery';

export default function hideShowContextualNav() {
    var $contextualNavViewer = $('#contextualNavViewer'), $contextualNav = $('.contextual-nav');

    $contextualNavViewer.on('click', function() {
        if (!$($contextualNav).is(':visible')) {
            $contextualNavViewer.addClass('is-shown');
            $contextualNav.show();
        } else {
            $contextualNavViewer.removeClass('is-shown');
            $contextualNav.hide();
        }
    });
}
